import React, { createContext, useContext, useState } from "react";

const ClinicContext = createContext();

export const ClinicProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null); // Add state for selectedPatient
  const [selectedSuggestion, setSelectedSuggestion] = useState(null); // Add state for selected suggestion

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const toggleEditModal = () => {
    setShowEditModal((prev) => {
      if (prev === null) {
        return true; // If state is null, set it to true
      } else {
        return !prev; // Toggle between true and false
      }
    });
  };

  const handleSuggestion = (suggestion) => {
    setSelectedSuggestion(suggestion); // Save selected suggestion in state
    // You can add more logic here if needed
  };

  return (
    <ClinicContext.Provider
      value={{
        isSidebarOpen,
        toggleSidebar,
        showEditModal,
        toggleEditModal,
        selectedPatient,
        setSelectedPatient,
        selectedSuggestion, // Include selected suggestion in the context value
        handleSuggestion, // Pass the handler function to the context
      }}
    >
      {children}
    </ClinicContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(ClinicContext);
  if (!context) {
    throw new Error("useClinic must be used within a ClinicProvider");
  }
  return context;
};
